import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useState, useEffect } from 'react';
import { setVBCUser } from '../components/WtOneClick/utils/setVBCUser';
export var useVBCUser = function useVBCUser(_ref) {
  var isAuthenticated = _ref.isAuthenticated,
    authorization = _ref.authorization,
    isVbcUserSet = _ref.isVbcUserSet,
    setIsVbcUserSet = _ref.setIsVbcUserSet;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    vbcError = _useState2[0],
    setVbcError = _useState2[1];
  useEffect(function () {
    var initVBCUser = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(idToken, cheggGraphQLUrl) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return setVBCUser(idToken, cheggGraphQLUrl);
            case 3:
              setIsVbcUserSet(true);
              _context.next = 9;
              break;
            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](0);
              setVbcError(_context.t0);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 6]]);
      }));
      return function initVBCUser(_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }();
    if (isAuthenticated && authorization.idToken && authorization.cheggGraphQLUrl && !isVbcUserSet) {
      initVBCUser(authorization.idToken, authorization.cheggGraphQLUrl);
    }
  }, [isAuthenticated, authorization.idToken, authorization.cheggGraphQLUrl, isVbcUserSet]);
  return {
    vbcError: vbcError
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/dist/esm/hooks/useVBCUser.js
// module id = 5231
// module chunks = 11